export const users_sorting = [
  { label: "Name and surname", value: "first_name:asc" },
  { label: "Name and surname", value: "first_name:desc" },
  { label: "Website [SHORT]", value: "websites:asc" },
  { label: "Website [SHORT]", value: "websites:desc" },
  { label: "Account type", value: "type:asc" },
  { label: "Account type", value: "type:desc" },
];